export default function NotFound() {
  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold">Page not found</h2>
    </div>
  );
}
